<div class="modal-header">
  <h4 class="modal-title">
    {{'projectRequestPopup.title' | translate}}
  </h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <p>{{ (isRequestSingleQuoteMode ? 'projectRequestPopup.message.approve_project' : 'projectRequestPopup.message.approve_projects') | translate }}</p>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary btn-cancel" (click)="close()">{{'global.label.cancel' | translate}}</button>
  <button type="button" class="btn btn-secondary btn-forward btn-single-row" [hidden]="!isChangeProjectStateAvailable() || !isRequestSingleQuoteMode" (click)="changeProjectState()">{{'chooseFinalizationAction.selection.setToRequested' | translate}}</button>
  <button type="button" class="btn btn-primary btn-forward" *ngIf="isRequestSingleQuoteMode" #checkProjectButton (click)="checkProject()">{{'projectRequestPopup.label.check_project' | translate}}</button>
  <button type="submit" class="btn btn-forward" [ngClass]="isRequestSingleQuoteMode ? 'btn-secondary' : 'btn-primary'" (click)="approveProject()">
    {{ (isRequestSingleQuoteMode ? 'projectRequestPopup.label.approve_project' : 'projectRequestPopup.label.approve_projects') | translate }}
  </button>
</div>
